import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { hideGuestAccessMessage } from "../../../features/guest/guestSlice";
import {
  updateDimmed,
  updateLoginVisible,
  updateSignupVisible,
  updateContactVisible
} from "../../../features/forms/formsSlice";
import {
  logout,
  clearAuthError,
  clearSignupSuccess,
} from "../../../features/auth/authSlice";
import { UserIcon, UserWrapper, UserItem, YouAreLogged, FullScreenWrapper } from "./UserStyle";
import { header } from "../../../i18n/01_header";
import ContactForm from "../../03_footer/01_contactform/ContactForm";


const User = ({ userMenu, setUserMenu, setHambMenu }) => {

  const dispatch = useDispatch();

  const accessAttemptId = useSelector(
    (state) => state.guest.accessAttemptId
  );

  const { token, user, lastSignupSuccess } = useSelector(
    (state) => state.auth
  );

  const { students, selectedStudentId } = useSelector(
    (state) => state.teacher || { students: [], selectedStudentId: null }
  );

  const lang = useSelector(state => state.lang.lang)

  const t = header[lang]

  const selectedStudent =
    students?.find((s) => s.id === selectedStudentId) || null;
  const selectedStudentName =
    selectedStudent?.name || selectedStudent?.email || "";


  // derive label for YouAreLogged + colour
  let loggedLabel = "logged out";
  if (token && user) {
    loggedLabel = "logged in";
  } else if (!token && lastSignupSuccess) {
    loggedLabel = "now registered";
  }

  const userName = user?.username || user?.email;

  const showUserMenu = () => {
    setHambMenu(false);
    setUserMenu(!userMenu);
  };

  const clickOutside = () => {
    setUserMenu(false)
  }

  const showUserItem = (e) => {
    const selectedItem = e.target.id;
    setUserMenu(false);

    if (selectedItem === "now registered") {
      // open Sign Up modal
      dispatch(updateDimmed(true));
      dispatch(updateSignupVisible(true));
    } else if (selectedItem === "logged in") {
      // open Login modal
      dispatch(updateDimmed(true));
      dispatch(updateLoginVisible(true));
    } else if (selectedItem === "logged out") {
      // Exit = real logout
      dispatch(logout());
      dispatch(clearAuthError());
      dispatch(clearSignupSuccess()); // here we *do* reset "now registered"
    }
  };

  const contactForm = () => {
    dispatch(updateContactVisible(true))
    dispatch(updateDimmed(true))
  }

  const [guestMessage, setGuestMessage] = useState("");

  const isGuest = !token && !user;

  // ✅ Text to show
  // const displayText = guestMessage
  //   ? guestMessage
  //   : `You are ${loggedLabel}${loggedLabel === "logged in" && userName ? ` as ${userName}` : ""
  //   }${loggedLabel === "logged in" &&
  //     user?.role === "TEACHER" &&
  //     selectedStudentName
  //     ? ` for ${selectedStudentName}`
  //     : ""
  //   }`;

  useEffect(() => {
    if (!isGuest) return;
    setGuestMessage(t.guest)
    const time = setTimeout(() => setGuestMessage(""), 2500);
    return () => clearTimeout(time);
  }, [accessAttemptId, isGuest]);

  return (
    <div>
      <FullScreenWrapper
      onClick={clickOutside}
      onTouchMove={clickOutside}
      userMenu={userMenu}
      ></FullScreenWrapper>
      <UserIcon onClick={showUserMenu} />
      {userMenu && (
        <UserWrapper>
          {user?.role === undefined ?
            <UserItem id="logged in" onClick={showUserItem} to="/">
              Login
            </UserItem>
            : ""
          }
          {
            user?.role === "ADMIN"
              ?
              <UserItem id="now registered" onClick={showUserItem} to="/">
                Signup
              </UserItem>
              :
              user?.role === undefined
                ?
                <UserItem id="now registered" onClick={contactForm} to="#">
                  Signup
                </UserItem>
                :
                ""
          }

          {/* ✅ Only show for admins */}
          {token && user?.role === "ADMIN" && (
            <UserItem onClick={showUserItem} to="/admin">
              Admin Console
            </UserItem>
          )}

          {/* ✅ Only show for teachers */}

          {token && user?.role === "TEACHER" && (
            <UserItem onClick={showUserItem} to="/teacher">
              Teacher Portal
            </UserItem>
          )}

          <UserItem id="logged out" onClick={showUserItem} to="/">
            Exit
          </UserItem>
        </UserWrapper>
      )}

      <YouAreLogged logged={loggedLabel}
        guestMessage={guestMessage}
      >
        {guestMessage ||
          `You are ${loggedLabel}${loggedLabel === "logged in" && userName ? ` as ${userName}` : ""
          }${loggedLabel === "logged in" &&
            user?.role === "TEACHER" &&
            selectedStudentName
            ? ` for ${selectedStudentName}`
            : ""
          }`}
      </YouAreLogged>

    </div>
  );
};

export default User;
